import * as OpenSansRegular from '@app/src/assets/fonts/open-sans/open-sans-regular.woff2';
import * as AristotelicaRegular from '@app/src/assets/fonts/aristotelica/aristotelica-regular.woff2';
import * as AristotelicaExtraLight from '@app/src/assets/fonts/aristotelica/aristotelica-extralight.woff2';

export const fonts = `
  @font-face{
    font-family: open-sans;
    src: url(${OpenSansRegular}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: aristotelica;
    src: url(${AristotelicaRegular}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: aristotelica-extralight;
    src: url(${AristotelicaExtraLight}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
`;
